import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { AuthserviceService } from './authservice.service';
import { AuthService } from '../modules/auth/_services/auth.service';

// import { stagger } from '@angular/animations';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { BASE_URL, LAIA_BASE_URL } from '../constant/constant.component';
import { JsonPipe } from '@angular/common';
import { TranslationService } from '../modules/i18n/translation.service';
import { lang } from 'moment';

// import { retry, catchError } from 'rxjs/operators';


@Injectable({
    providedIn: 'root',
})
export class MainService implements OnInit {
    private password = new BehaviorSubject('email');
    changePassword = this.password.asObservable();
    language: string ;
    locale: any;

    changeMessage(message: string) { this.password.next(message) }

    private resource = new BehaviorSubject('resource');
    changeResource = this.resource.asObservable();

    changeContent(message: string) { this.resource.next(message) }

    // baseURL = "http://localhost:8080/mrroom";

    baseURL = BASE_URL;
    laiaBaseURL = LAIA_BASE_URL


    constructor(private http: HttpClient,
        private authService: AuthserviceService,
        private translationService: TranslationService,
        private auth: AuthService) { }

    

    ngOnInit() {
                 
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;

        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        return throwError(errorMessage);
    }


    post(url, datas) {
        const httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept-Language': ''+ this.locale
        });
        return this.http.post(
            this.baseURL + url,
            datas, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }

    getcountry(url) {
        const httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.http.get(
            this.baseURL + url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    postModal(url, userRole) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.post(
            this.baseURL + url,
            userRole, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }

    postCsv(url, userRole) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.post(
            this.baseURL + url,
            userRole, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }

    putModal(url, userRole) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.put(
            this.baseURL + url,
            userRole, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }

    updateOpenSpaceModal(url, openSpace) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.put(
            this.baseURL + url,
            openSpace, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }

    createOpenSpaceModal(url, openSpace) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.put(
            this.baseURL + url,
            openSpace, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }


    putMeetingRoom(url, id) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.put(
            this.baseURL + url, id, { headers: httpHeaders }).pipe(tap((response) => { }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }


    postKiosk(url, data, file) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();
        const kioskBlob = new Blob([data as BlobPart], { type: "application/json" });
        formData.append('file', file);
        formData.append('kiosk', kioskBlob);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    postViewPoint(url, data, file) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();
        const viewPointBlob = new Blob([data as BlobPart], { type: "application/json" });
        formData.append('file', file);
        formData.append('viewPointDTO', viewPointBlob);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }
    

    get(url) {
        this.locale = this.translationService.getSelectedLanguage();
        
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });

        return this.http.get(
            this.baseURL + url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => { }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    getWithoutToken(url) {
        this.locale = this.translationService.getSelectedLanguage();
        
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });

        return this.http.get(
            this.baseURL + url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => { }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    getOpenSpace(url) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.baseURL + url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    findModal(url) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.baseURL + url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    updateModal(url, updateUsers) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.put(
            this.baseURL + url,
            updateUsers, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }

    deleteModel(url) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.baseURL + url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    postFile(url, file, imageUrl) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();

        formData.append('file', file);
        formData.append('url', imageUrl);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    findLogo(url, id) {
        // const httpHeaders = new HttpHeaders({
        //     'Accept': 'application/json',
        //     'Content-Type': 'application/json',
        //     'Authorization': ' ' + this.authService.getBarierToken()
        // });
        // let params = new HttpParams();
        // params.set('id', id)
        // return this.http.get(
        //    ( this.baseURL + url, {params: params}), { headers: httpHeaders, responseType: 'text' })
        //     .pipe(tap((response) => {
        //     }, error => {
        //         if (error.status == 403) {
        //             this.auth.logout();
        //         }
        //     }));
    }

    saveLogo(url, fileData, imageUrl) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();

        formData.append('file', fileData);
        formData.append('url', imageUrl);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    updateWithFormData(url, fileData, updateData) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();
        const meetingRoomBlob = new Blob([JSON.stringify(updateData) as BlobPart], { type: "application/json" });
        formData.append('file', fileData);
        formData.append('meetingRoomDTO', meetingRoomBlob);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    deskUpdateWithFormData(url, fileData, updateData) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();
        const deskBlob = new Blob([JSON.stringify(updateData) as BlobPart], { type: "application/json" });
        formData.append('file', fileData);
        formData.append('deskDTO', deskBlob);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    carUpdateWithFormData(url, fileData, updateData) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();
        const deskBlob = new Blob([JSON.stringify(updateData) as BlobPart], { type: "application/json" });
        formData.append('file', fileData);
        formData.append('carDTO', deskBlob);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    carCheckoutWithFormData(url, fileData, updateData) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();
        const checkoutBlob = new Blob([JSON.stringify(updateData) as BlobPart], { type: "application/json" });

        if (fileData.length > 0) {
            fileData.forEach((file) => { formData.append('files', file); });
        } else {
            formData.append('files', fileData);
        }
        // formData.append('files', fileData);
        formData.append('checkoutDTO', checkoutBlob);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    putStykeSettingsFile(url, styleSettingsData, kioskCheckinFile, kioskCheckInformation, serviceViewPont) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();

        formData.append('styleSetting', styleSettingsData);
        formData.append('kioskCheckinBackGroundFile', kioskCheckinFile);
        formData.append('kioskInformationBackGroundFile', kioskCheckInformation);
        formData.append('serviceViewpointBackGroundFile', serviceViewPont);

        return this.http.put(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

   
    postExtendTimeDur(url, data) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.baseURL + url, {
            params: {
                id: data.id,
                duration: data.duration
            }, headers: httpHeaders, responseType: 'text'
        })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }
    

    postEquipAndLocationIds(url, data) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.baseURL + url, {
            params: {
                locationId: data.id,
                equipmentIds: data.equipmentIds
            }, headers: httpHeaders, responseType: 'text'
        })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    allowEndUser(url, allowValue, id) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.baseURL + url, {
            params: {
                id: id,
                status: allowValue
            }, headers: httpHeaders, responseType: 'text'
        }).pipe(tap((response) => {
        }, error => {
            if (error.status == 403) {
                this.auth.logout();
            }
        }));
    }


    delete(url) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
            
        });
        return this.http.delete(
            this.baseURL + url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }


    //login into laia
   

    getLaia(url){
        this.locale = this.translationService.getSelectedLanguage();
        
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': ''+ this.locale
        });

        return this.http.get(
            this.laiaBaseURL+url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => { }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            })); 
    }
    getHttpServiceWithDynamicParams(data: any, url: any) {

        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.baseURL + url, {
                params: data, headers: httpHeaders, responseType: 'text'
        }).pipe(tap((response) => {
        }, error => {
            if (error.status == 403) {
                this.auth.logout();
            }
        }));
      }

      getHttpServiceWithDynamicParamsForLaia(data: any, url: any) {

        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.laiaBaseURL + url, {
                params: data, headers: httpHeaders, responseType: 'text'
        }).pipe(tap((response) => {
        }, error => {
            if (error.status == 403) {
                this.auth.logout();
            }
        }));
      }
  
     displayUpdateWithFormData(url, fileData, updateData) {
        const httpHeaders = new HttpHeaders({
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        const formData = new FormData();
        const blob = new Blob([JSON.stringify(updateData) as BlobPart], { type: "application/json" });
        formData.append('file', fileData);
        formData.append('display', blob);

        return this.http.post(
            this.baseURL + url, formData, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }

    postModalForLaia(url, userRole) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.post(
            this.laiaBaseURL + url,
            userRole, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }
    deleteModelForLaia(url) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.get(
            this.laiaBaseURL + url, { headers: httpHeaders, responseType: 'text' })
            .pipe(tap((response) => {
            }, error => {
                if (error.status == 403) {
                    this.auth.logout();
                }
            }));
    }
    putModalForLaia(url, updateUsers) {
        const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': ' ' + this.authService.getBarierToken(),
            'Accept-Language': ''+ this.locale
        });
        return this.http.put(
            this.laiaBaseURL + url,
            updateUsers, { headers: httpHeaders })
            .pipe(
                tap((response) => {
                }, error => {
                    if (error.status == 403) {
                        this.auth.logout();
                    }
                })
            );
    }

}
